export default __webpack_public_path__ + "static/media/groovy-cfs.05390490.jpg";